import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getUserFeatures, type UserData, type UserFeatures } from "@/entities/User";
import { UserRole } from "@/shared/const/userRole";

import { getAuthUserData } from "../model/selectors/getAuthSelectors";

type ExtendedUserData = UserData &
  UserFeatures & {
    role: UserRole;
  };

export const useUser = (): ExtendedUserData => {
  const userData = useSelector(getAuthUserData);

  return useMemo(() => {
    if (!userData) {
      return null;
    }

    let role = UserRole.Customer;
    if (userData.isWriter) {
      role = UserRole.Writer;
    }

    const result: ExtendedUserData = { ...userData, role, ...getUserFeatures(userData) };

    return result;
  }, [userData]);
};
